<div *ngIf="showConfirm">
  <!-- <div class="cpmodal"> -->
    <div class="cpmodal-content">
      <div class="cpmodal-header">

        <h2 style="display:inline-block">Confirm</h2>
        <span class="cpclose" >&times;</span>
      </div>
      <div class="cpmodal-body">
        <b>{{message}}</b><br><br>
        <button class="btn btn-warning btn-sm" style="margin-left:50px" (click)="yes()">Yes</button>
        <button class="btn btn-info btn-sm" style="margin-left:50px" (click)="no()">No</button>
      </div>

    </div>
  <!-- </div> -->
</div>
<!-- <span  style="padding-bottom:20px;background-color: rgb(255, 214, 125);"></span> -->